import {
  Box,
  Container,
  Grid,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  COMPANY_NAME,
  CUSTOM_THEME_COLORS,
  FONT_STYLE,
  TRANSITION_DURATION,
} from '../../variables';
import AboutUs from './AboutUs';
import ContactUs from './ContactUs';
import CustomerSupport from './CustomerSupport';
import FooterMobileAccordion from './FooterMobileAccordion';
import SocialMedia from './SocialMedia';

export const FooterTitles = styled(Typography)(({ theme }) => ({
  textAlign: { xs: 'center', md: 'initial' },
  marginBottom: theme.spacing(2),
}));

const Footer = () => {
  const theme = useTheme();
  const DESKTOP_DEVICES = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
      <Box
        sx={{
          backgroundColor: CUSTOM_THEME_COLORS.primary,
          position: { xs: 'relative', md: 'initial' },
          zIndex: { xs: 2, md: 'initial' },
        }}
      >
        <Box
          sx={{
            marginTop: { xs: 4, md: 6 },
            paddingTop: { xs: 4, md: 5 },
            paddingBottom: { xs: 2, md: 5 },
            color: 'white',
          }}
        >
          <Container maxWidth='lg'>
            <Grid
              container
              spacing={{ xs: 0, md: 5 }}
            >
              {DESKTOP_DEVICES ? (
                <>
                  <SocialMedia />
                  <AboutUs />
                  <CustomerSupport />
                  <ContactUs />
                </>
              ) : (
                <Grid
                  item
                  xs={12}
                  sm={8}
                  sx={{
                    margin: '0 auto',
                  }}
                >
                  <SocialMedia />
                  <FooterMobileAccordion />
                </Grid>
              )}
            </Grid>
          </Container>
        </Box>

        <Box>
          <Container maxWidth='lg'>
            <Grid container>
              <Box
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  borderTop: { md: '1px solid rgba(255, 255, 255, 0.40)' },
                  color: 'white',
                }}
              >
                <Typography
                  sx={{
                    paddingY: 2,
                  }}
                >
                  {COMPANY_NAME} © 2023&nbsp;.&nbsp;
                  <Typography
                    component='a'
                    href='https://www.bdcadigital.com/plataforma-de-ecommerce-b2b'
                    title='Powered by BDCA Digital'
                    target='_blank'
                    sx={{
                      fontSize: 'inherit',
                      fontWeight: FONT_STYLE.medium,
                      textDecoration: 'none',
                      transition: `opacity ${TRANSITION_DURATION}ms ease`,
                      '&:hover': { opacity: '.75' },
                    }}
                  >
                    B2B Platform by BDCA Digital
                  </Typography>
                </Typography>
              </Box>
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
